/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import { gql } from 'urql';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** The cost of the product may vary depending on the channel of the order. Use DELIVERY_COST_CHANNEL if the current order is delivery, and DEFAULT_COST_CHANNEL otherwise. Marketplace and Outpost cost channels are implicit based on the request and restaurant. */
export type CostChannel = 'DEFAULT_COST_CHANNEL' | 'DELIVERY_COST_CHANNEL' | 'PICKUP_COST_CHANNEL';

export type ProductDetailsProductQueryVariables = Exact<{
  id: string | number;
  costChannel?: Types.CostChannel | null | undefined;
}>;

export type ProductDetailsProductQuery = {
  readonly product: {
    readonly __typename: 'Product';
    readonly id: string;
    readonly name: string;
    readonly calories: number;
    readonly cost: number;
    readonly asset: { readonly url: string };
    readonly ingredients: ReadonlyArray<{
      readonly __typename: 'Ingredient';
      readonly id: string;
      readonly totalCarbsG: number | null;
      readonly proteinG: number | null;
      readonly totalFatG: number | null;
      readonly dietaryFiberG: number | null;
    }>;
  };
};

export type ProductDetailsBaseProductQueryVariables = Exact<{
  slug: string;
}>;

export type ProductDetailsBaseProductQuery = {
  readonly baseProduct: {
    readonly __typename: 'BaseProduct';
    readonly id: string;
    readonly name: string;
    readonly description: string;
    readonly heading: string;
    readonly subheading: string;
    readonly totalCarbsG: number | null;
    readonly totalFatG: number | null;
    readonly transFatG: number | null;
    readonly sugarsG: number | null;
    readonly sodiumMg: number | null;
    readonly saturatedFatG: number | null;
    readonly proteinG: number | null;
    readonly cholesterolMg: number | null;
    readonly caloriesFromFat: number | null;
    readonly calories: number | null;
    readonly dietaryFiberG: number | null;
    readonly asset: { readonly url: string };
  } | null;
};

export type ProductDetailsProductForRestaurantQueryVariables = Exact<{
  baseProductSlug: string;
  restaurantId: string;
  costChannel?: Types.CostChannel | null | undefined;
}>;

export type ProductDetailsProductForRestaurantQuery = {
  readonly productForRestaurant: {
    readonly __typename: 'Product';
    readonly id: string;
    readonly slug: string;
    readonly name: string;
    readonly calories: number;
    readonly isModifiable: boolean;
    readonly outOfStock: boolean;
    readonly cost: number;
    readonly ingredients: ReadonlyArray<{
      readonly __typename: 'Ingredient';
      readonly id: string;
      readonly proteinG: number | null;
      readonly saturatedFatG: number | null;
      readonly sodiumMg: number | null;
      readonly sugarsG: number | null;
      readonly totalCarbsG: number | null;
      readonly totalFatG: number | null;
      readonly transFatG: number | null;
      readonly co2eKg: number | null;
      readonly cholesterolMg: number | null;
      readonly caloriesFromFat: number | null;
      readonly dietaryFiberG: number | null;
    }>;
    readonly restaurant: {
      readonly __typename: 'Restaurant';
      readonly id: string;
      readonly slug: string;
    };
  } | null;
};

export const ProductDetailsProductDocument = gql`
  query ProductDetailsProduct($id: ID!, $costChannel: CostChannel) {
    product(id: $id) {
      __typename
      id
      name
      cost: channelCost(costChannel: $costChannel)
      calories
      asset {
        url
      }
      ingredients {
        __typename
        id
        totalCarbsG
        proteinG
        totalFatG
        dietaryFiberG
      }
    }
  }
`;

export function useProductDetailsProductQuery(
  options: Omit<Urql.UseQueryArgs<ProductDetailsProductQueryVariables>, 'query'>,
) {
  return Urql.useQuery<ProductDetailsProductQuery, ProductDetailsProductQueryVariables>({
    query: ProductDetailsProductDocument,
    ...options,
  });
}
export const ProductDetailsBaseProductDocument = gql`
  query ProductDetailsBaseProduct($slug: String!) {
    baseProduct(slug: $slug) {
      __typename
      id
      name
      description
      heading
      subheading
      totalCarbsG
      totalFatG
      transFatG
      sugarsG
      sodiumMg
      saturatedFatG
      proteinG
      cholesterolMg
      caloriesFromFat
      calories
      dietaryFiberG
      asset {
        url
      }
    }
  }
`;

export function useProductDetailsBaseProductQuery(
  options: Omit<Urql.UseQueryArgs<ProductDetailsBaseProductQueryVariables>, 'query'>,
) {
  return Urql.useQuery<ProductDetailsBaseProductQuery, ProductDetailsBaseProductQueryVariables>({
    query: ProductDetailsBaseProductDocument,
    ...options,
  });
}
export const ProductDetailsProductForRestaurantDocument = gql`
  query ProductDetailsProductForRestaurant(
    $baseProductSlug: String!
    $restaurantId: String!
    $costChannel: CostChannel
  ) {
    productForRestaurant(baseProductSlug: $baseProductSlug, restaurantId: $restaurantId) {
      __typename
      id
      slug
      name
      cost: channelCost(costChannel: $costChannel)
      calories
      isModifiable
      outOfStock
      ingredients {
        __typename
        id
        proteinG
        saturatedFatG
        sodiumMg
        sugarsG
        totalCarbsG
        totalFatG
        transFatG
        co2eKg
        cholesterolMg
        caloriesFromFat
        dietaryFiberG
      }
      restaurant {
        __typename
        id
        slug
      }
    }
  }
`;

export function useProductDetailsProductForRestaurantQuery(
  options: Omit<Urql.UseQueryArgs<ProductDetailsProductForRestaurantQueryVariables>, 'query'>,
) {
  return Urql.useQuery<
    ProductDetailsProductForRestaurantQuery,
    ProductDetailsProductForRestaurantQueryVariables
  >({ query: ProductDetailsProductForRestaurantDocument, ...options });
}
